import { render, staticRenderFns } from "./ManagerSettings.vue?vue&type=template&id=63b95148&lang=pug&"
import script from "./ManagerSettings.vue?vue&type=script&lang=js&"
export * from "./ManagerSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports